"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadKeypair = void 0;
const fs_1 = __importDefault(require("fs"));
const bs58_1 = __importDefault(require("bs58"));
const web3_js_1 = require("@solana/web3.js");
function loadKeypair(privateKey) {
    // try to load privateKey as a filepath
    let loadedKey;
    if (fs_1.default.existsSync(privateKey)) {
        privateKey = fs_1.default.readFileSync(privateKey).toString();
    }
    if (privateKey.includes('[') && privateKey.includes(']')) {
        loadedKey = Uint8Array.from(JSON.parse(privateKey));
    }
    else if (privateKey.includes(',')) {
        loadedKey = Uint8Array.from(privateKey.split(',').map((val) => Number(val)));
    }
    else {
        privateKey = privateKey.replace(/\s/g, '');
        loadedKey = new Uint8Array(bs58_1.default.decode(privateKey));
    }
    return web3_js_1.Keypair.fromSecretKey(Uint8Array.from(loadedKey));
}
exports.loadKeypair = loadKeypair;
